<template>
<div class="chapter">
<div class="inner_page">
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<p class="timebreak"> <br/></p>
<blockquote><p class="center"><a id="pvii"></a> <span style="font-size: smaller">MY LOVE WILL STAY</span><br/>
<span style="font-size: smaller">TILL THE RIVERBED RUN DRY.</span></p></blockquote><blockquote><p class="center">—<em>PJ Harvey</em></p></blockquote>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// front03.vue?320067c6